// Include jQuery plugins
//require('jquery.sample');

// Import non-jQuery modules
//const sample = require('sample');

// Define wp_localize_script handles
/* global handorgel */

(function($) {
    const wntrTheme = {
        body: $('body'),
        html: $('html'),
        document: $(document),

        /**
         * Initialise theme JS on page load
         */
        init: function() {
            // Do we have JS?
            $('html').removeClass('no-js');

            // Automatically call all methods that start with __, in the order they're defined
            for(const prop in wntrTheme) {
                if(prop.startsWith('__') && typeof wntrTheme[prop] === 'function') {
                    wntrTheme[prop].call();
                }
            }
        },

        __signupEvents: () => {
            wntrTheme.body.on('click', '.signup-form__apply-now', function() {
                $(this).siblings('.gfield-choice-input').prop("checked", true);
                $(this).parents('.gform_page').find('.gform_next_button').trigger('click');
            });
        },

        /**
         * Toggle header menu
         */
        __toogleHeaderMenu: () => {
            const mobileBtn = wntrTheme.body.find('.header__toggle-menu');
            const mobileMenu = wntrTheme.body.find('.mobile-menu');
            mobileBtn.on('click', function() {
                $(this).toggleClass('is-active');
                mobileMenu.toggleClass('is-active');
                wntrTheme.body.toggleClass('body--fixed');
            });
        },

        /**
         * Init accordions
         */
        __initAccordions: () => {
            if(wntrTheme.body.find('.handorgel').length) {
                $.each(wntrTheme.body.find('.handorgel'), function() {
                    new handorgel($(this)[0]);
                });
            }
        },

        /**
         * Handle popup news window
         */
        __popupHandler: () => {

            if(!getCookie('user_has_closed_popup')) {
                wntrTheme.body.addClass('popup-is-shown');
            }

            const popup = wntrTheme.body.children('.news').first();

            if(popup.length && wntrTheme.body.hasClass('popup-is-shown')) {

                popup.find('.news__close').on('click', () => {
                    wntrTheme.body.removeClass('popup-is-shown');
                    setCookie('user_has_closed_popup', 'true', 7);
                });

            }

            function setCookie(cname, cvalue, exdays) {
                const d = new Date();
                d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
                const expires = "expires=" + d.toUTCString();
                document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
            }

            function getCookie(cname) {
                const name = cname + "=";
                const decodedCookie = decodeURIComponent(document.cookie);
                const ca = decodedCookie.split(';');
                for(let i = 0; i < ca.length; i++) {
                    let c = ca[i];
                    while(c.charAt(0) === ' ') {
                        c = c.substring(1);
                    }
                    if(c.indexOf(name) === 0) {
                        return c.substring(name.length, c.length);
                    }
                }
                return "";
            }
        },
    };

    $(document).ready(wntrTheme.init);
})(jQuery);